/**
 * React Hook for Notifications
 * 
 * Provides real-time notification data with React Query caching
 */

import { useQuery } from '@tanstack/react-query';
import {
  getAllNotifications,
  getNotificationSummary,
  getCriticalNotifications,
} from '../api/notificationDetection';

// Fetch all notifications
export function useNotifications() {
  return useQuery({
    queryKey: ['notifications'],
    queryFn: getAllNotifications,
    staleTime: 2 * 60 * 1000, // 2 minutes
    refetchInterval: 5 * 60 * 1000, // Refresh every 5 minutes
  });
}

// Fetch notification summary (lighter query for badge counts)
export function useNotificationSummary() {
  return useQuery({
    queryKey: ['notifications', 'summary'],
    queryFn: getNotificationSummary,
    staleTime: 2 * 60 * 1000, // 2 minutes
    refetchInterval: 5 * 60 * 1000, // Refresh every 5 minutes
  });
}

// Fetch only critical notifications
export function useCriticalNotifications() {
  return useQuery({
    queryKey: ['notifications', 'critical'],
    queryFn: getCriticalNotifications,
    staleTime: 1 * 60 * 1000, // 1 minute for critical
    refetchInterval: 2 * 60 * 1000, // Check every 2 minutes
  });
}
